module.exports = __webpack_public_path__ + "img/community.c5e1e088.jpg";